export function RadioBasic({checked, name}) {

    return (
        <input className="form-check-input me-1 shadow-none" type="radio" name={name} checked={checked} onChange={() => {}} />
    );
}